import Axios from "@/plugins/Axios";

const BASE_URL = "ponto-colaboradores";

export class ColaboradorFeriasService {
  async listar(params = {}) {
    const response = await Axios().get(`${BASE_URL}/admin/ferias`, { params });
    return response.data;
  }

  async listarMinhas(params = {}) {
    const response = await Axios().get(`${BASE_URL}/ferias/minhas`, { params });
    return response.data;
  }

  async obterPorId(id) {
    const response = await Axios().get(`${BASE_URL}/admin/ferias/${id}`);
    return response.data;
  }

  async salvar(dados) {
    const response = await Axios().post(`${BASE_URL}/admin/ferias`, dados);
    return response.data;
  }

  async atualizar(id, dados) {
    const response = await Axios().put(`${BASE_URL}/admin/ferias/${id}`, dados);
    return response.data;
  }

  async excluir(id) {
    const response = await Axios().delete(`${BASE_URL}/admin/ferias/${id}`);
    return response.data;
  }
}

export default new ColaboradorFeriasService();
